import { useEffect } from "react";
import notFoundImg from "../images/page_not_found.svg";

export default function PageNotFound() {
  useEffect(() => {
    document.title = "404 | Page Not Found";
  }, []);
  return (
    <div style={styles.container}>
      <img src={notFoundImg} alt="Not Found" style={styles.svg} />
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  svg: {
    width: "42%",
    maxWidth: "80%",
    marginBottom: "20px"
  }
};
